module.exports = __webpack_public_path__ + "slogen_mil.7d37d214.jpg";